import React from "react";
import { connect } from "react-redux";
import { compose, bindActionCreators } from "redux";
import { Button } from "../../Components/button";
import { withAuth, withTitle } from "../../HoC";
import { translate } from "../../translations/translate";

export const Profile = (props) => {

  const logout = () => {
    localStorage.removeItem("token");
    props.history.push("/login");
  };

  return (<div>
    <Button onClick={logout} label="LOG OUT" />
  </div>);
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>  ({
  actions : bindActionCreators({
  }, dispatch),
});

export default compose(
  withTitle(translate("map")),
  withAuth(0),
  connect(mapStateToProps, mapDispatchToProps),
)(Profile);
